import { NotepadText } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

export const LastNoteTooltip = ({ lastNote }: { lastNote: string }) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="mx-auto flex w-9 items-center justify-center rounded-full border border-solid border-slate-200 py-0.5">
          <NotepadText size={16} />
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <span
          className="line-clamp-[8] text-sm font-normal break-words text-ellipsis"
          dangerouslySetInnerHTML={{ __html: lastNote }}
        />
      </TooltipContent>
    </Tooltip>
  );
};
